<template>
  <div>
    <div>
      <p class="ma-0 font-weight-medium">
        {{coluna.texto}}
      </p>
      <p class="ma-0 mt-n1">
        <template v-if="detalhamento_categoria.unidade_compra !== '-'">
          {{ `${Helpers.formatarValor(detalhamento_categoria.lote_minimo)} ${detalhamento_categoria.unidade_compra}` }}
          <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
        </template>
        <template v-else>-</template>
      </p>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      width="400"
      content-class="bra-20"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
            <span>Lote Mínimo</span>
          <v-spacer />
          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <TextFieldFormatadorDeValor
            v-model="lote_minimo"
            outlined
            label="Lote mínimo"
            :error-messages="LOTE_MINIMO"
            @focus="$event.target.select()"
            @keyup.enter="alterarValorLoteMinimo()"
          />
        </v-card-text>

        <v-card-actions class="mt-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="alterarValorLoteMinimo()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>

</template>

<script>
import { alterarLoteMinimo } from "../../../../api/compraPorDepartamentos/Categoria"
import { logout } from '../../../../helpers';
import TextFieldFormatadorDeValor from '../../../utils/TextFieldFormatadorDeValor.vue'
import {required, minValue} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";
import {parametros_rota} from "../helpers/ParametrosRota";

export default {
  name: 'LoteMinimo',
  mixins: [parametros_rota],
  components: { TextFieldFormatadorDeValor },
  props: {
    coluna: Object,
    detalhamento_categoria: Object,
    categoria: Object
  },
  data () {
    return {
      dialog_ativo: false,
      lote_minimo: 0,
    }
  },
  validations: {
    lote_minimo: {
      required,
      minValue: minValue(1),
    }
  },
  watch: {
    dialog_ativo(valor) {
      if(valor) {
        this.lote_minimo = this.detalhamento_categoria.lote_minimo;
      }
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarTabelaCategorias': 'comprasPorDepartamentos/callbackAtualizarTabelaCategorias'
    }),
    LOTE_MINIMO() {
      const errors = [];
      if (!this.$v.lote_minimo.$dirty) return errors;
      !this.$v.lote_minimo.required && errors.push("Campo Obrigatório.");
      !this.$v.lote_minimo.minValue && errors.push("Insira um valor inteiro.");
      return errors;
    }
  },
  methods: {
    alterarValorLoteMinimo() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const params = {
        grupo: this.grupo_compra,
        categoria: this.categoria.idcategoria,
        lote_minimo: parseFloat(this.lote_minimo)
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        alterarLoteMinimo(params)
          .then(() => {
            this.dialog_ativo = false;
            this.callbackAtualizarTabelaCategorias();
            this.$emit("novo-lote-minimo", this.lote_minimo);
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style>

</style>
